import type { ForumTag } from '~/api/forum/types';
import type { IllustrationName } from '~/components';

export const illustrationForForumTag = (forumTag: ForumTag) =>
  (
    ({
      Announcements: 'Announcements',
      FreelanceLife: 'Freelancers',
      VisualCommunication: 'VisualCommunication',
      DigitalDesign: 'DigitalDesign',
      Photography: 'Photography',
      Audiovisual: 'Audiovisual',
      LanguageAndCommunication: 'LanguageAndCommunication',
      ItDevelopment: 'ItDevelopment',
      PerformingArtists: 'PerformingArtist',
      OnlineContentCreation: 'ContentCreation',
    }) as const satisfies Record<ForumTag, IllustrationName>
  )[forumTag];
